Dell = window.Dell || {};
Dell.Types = Dell.Types || {};
Dell.OnlineUtils = Dell.OnlineUtils || {};

Dell.Types.SupportHomepage.prototype.handleCoveoSearchQuery = function(searchinput) {
    var inputData = Dell.Types.SupportHomepage.prototype.getValidateEntityApiInput(searchinput);
    var request = $.ajax({
        url: Dell.OnlineUtils.AppSettings.Unified.UnifiedValidateEntityApiUri,
        method: "POST",
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(inputData)
    });
    request.done(function(response) {
        if (response) {
            try {
                if (response &&
                    response.EntrySelectionType &&
                    response.EntrySelectionType !== '0' &&
                    response.LookupResults &&
                    response.LookupResults.length > 0) {
                    Dell.Types.SupportHomepage.prototype.handleRedirect(response.LookupResults, searchinput);
                } else {
                    if (typeof (Storage) !== "undefined") {
                        sessionStorage.IsEntityValidationPerformed = true;
                    }
                    Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage(searchinput);
                }
            } catch (e) {
                console.error('Dell.Types.SupportHomepage.prototype.handleCoveoSearchQuery.Done failed with exp : ' +
                    e);
                Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage(searchinput);
            }
        }
    });

    request.fail(function(jqXHR, textStatus) {
        console.error(
            "Request failed for Dell.Types.SupportHomepage.prototype.handleCoveoSearchQuery.ValidateEntrySelection: " +
            textStatus);
        Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage(searchinput);
    });
};

Dell.Types.SupportHomepage.prototype.getValidateEntityApiInput = function(searchinput) {

    var inputData = {
        Selection: Dell.Types.SupportHomepage.prototype.getSearchQuery(searchinput),
        appName: 'mastheadSearch'
    };

    return inputData;
};

Dell.Types.SupportHomepage.prototype.isScriptLoaded = function(url) {
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--;) {
        if (scripts[i].src == url) return true;
    }
    return false;
};

Dell.Types.SupportHomepage.prototype.handleRedirect = function(data, searchinput) {
    var url = data[0].TargetUrl;

    try {
        var redirectionType = "";
        switch (data[0].EsubType) {
        case 1:
            redirectionType = 'serviceTag';
            break;
        case 2:
            redirectionType = 'expressServiceCode';
            break;
        case 3:
            redirectionType = 'PSNT';
            break;
        case 4:
            redirectionType = 'serialNumber';
            break;
        case 5:
            redirectionType = 'serviceRequestNumber';
            break;
        case 6:
            redirectionType = 'Article';
            break;
        case 8:
            redirectionType = 'DriverId';
            break;
        case 9:
            redirectionType = 'Article';
            break;
        default:
            redirectionType = 'None';
            break;
        }

        redirectionType = redirectionType + ':' + Dell.Types.SupportHomepage.prototype.getSearchQuery(searchinput);
        if (redirectionType.indexOf("DriverId") > -1) {
            dellmetricsTrack_prop13_coveo_format(redirectionType);
        } else if (redirectionType.indexOf("Article") > -1) {
            dellmetricsTrack_prop13_coveo_format(redirectionType);
        }

        dellmetricsTrack_prop20_format("111.300.200.002", redirectionType);
    } catch (e) {
        console.error("Exception in Dell.Types.SupportHomepage.prototype.handleRedirect : " + url);
    }

    console.log("Dell.Types.SupportHomepage.prototype.handleRedirect : " + url);
    SecureRedirectUrl(url, false);
};

function dellmetricsTrack_prop13_coveo_format(value) {
    Dell.Metrics.sc.pagename = (Dell.Metrics.sc.country +
        '|' +
        Dell.Metrics.sc.language +
        '|' +
        Dell.Metrics.sc.segment +
        '|' +
        Dell.Metrics.sc.customerset +
        "|coveo|docsearchresults|" +
        '|' +
        value);
}

Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage = function(searchinput) {
    Dell.Types.SupportHomepage.prototype.setSearchProgressAction(false, searchinput);
    var searchString = Dell.Types.SupportHomepage.prototype.getSearchQuery(searchinput);
    var searchUrl = Dell.OnlineUtils.AppSettings.Unified.UnifiedSearchRedirectUrl +
        "#q=" +
        encodeURIComponent(searchString) +
        (Dell.Supportpage.getNewHash().length > 0 ? Dell.Supportpage.getNewHash() : "");
    SecureRedirectUrl(searchUrl);
};

Dell.Types.SupportHomepage.prototype.getSearchQuery = function(searchInput) {
    try {
        if (typeof ($(searchInput).val()) != "undefined")
            return $(searchInput).val().trim().replace(/</g, '').replace(/>/g, '');
    } catch (ex) {
        console.error("Error while getting value" + ex);
    }
};

Dell.Types.SupportHomepage.prototype.setSearchProgressAction = function(isProcessing, searchinput) {
    if (isProcessing &&
    (Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB === searchinput ||
        Dell.Supportpage.Constants.Selectors.SEARCH_INPUT == searchinput)) {
        if ($(Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB).is(":visible")) {
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM_MOB).find('button').css("display", "none");
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM_MOB).find('span').css("display", "");
        } else {
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM).find('button').css("display", "none");
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM).find('span').css("display", "");
        }
    } else {
        if ($(Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB).is(":visible")) {
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM_MOB).find('button').css("display", "").next('span')
                .css("display", "none");
        } else {
            $(Dell.Supportpage.Constants.Selectors.SEARCH_FORM).find('button').css("display", "").next('span')
                .css("display", "none");
        }
    }
};

$(document).on("keydown",
    "#search-input, #search-input-mob," + Dell.Supportpage.Constants.Selectors.UNIFIED_MASTHEAD,
    (function(e) {
        if ((e.which == 38 || e.which == 40) &&
            $("#ui-active-menuitem") !== undefined &&
            $("#ui-active-menuitem")[0] !== undefined) {
            $("#search-input").val($("#ui-active-menuitem")[0].innerText);
        }
    }));

function dellmetricsTrack_prop20_format(appcode, tabname) {
    if (typeof (dellmetricsTrack) === "function") {
        if (dellmetricsTrack) {
            dellmetricsTrack(appcode, tabname);
        }
    }
}